module.exports = __webpack_public_path__ + "static/media/Back_compagnie.c9cf6b70.jpg";